exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".notfound{margin-top:4rem}.notfound__headline{color:#000;font-size:2rem;font-weight:700;margin-top:0;margin-bottom:.5rem}.notfound__subline{color:#888;font-size:1.5rem;font-weight:500;margin-top:0;margin-bottom:2rem}.notfound a{text-decoration:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-4b87aed4!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Restricted.vue
// module id = 937
// module chunks = 0